import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import ColorPicker from './component';
import { useDeprecatedProps } from './use-deprecated-props';
export const LegacyAdapter = props => {
  return createElement(ColorPicker, useDeprecatedProps(props));
};
//# sourceMappingURL=legacy-adapter.js.map